import { IconButton } from "@mui/material";
import { ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { PageHeaderContext, useTableFiltersActions } from "@ryde/redux";

export const FilterClearButton = (): ReactElement => {
  const { t } = useTranslation();
  const { handleClearFilters } = useTableFiltersActions();
  const { onFiltersClear } = useContext(PageHeaderContext);

  const handleOnClick = async (): Promise<void> => {
    await handleClearFilters();
    onFiltersClear?.();
  };

  return (
    <IconButton
      data-e2e="clear_filters_button"
      title={t(`general.CLEAR_ALL_FILTERS`)}
      onClick={handleOnClick}
    >
      <PIC.FilterClearSvg />
    </IconButton>
  );
};
